/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { CIColors } from 'shared';

import { NodeStatus } from '../pages/ClusterPage/components/NodeStatus';

export const nodeStatusColors = {
  [NodeStatus.running]: CIColors.Success,
  [NodeStatus.updating]: CIColors.Tertiary,
  [NodeStatus.pending]: CIColors.Secondary,

  __fallback: CIColors.GraphicElements,
};
